<template>
  <div class="container">
    <h1 class="display-6 text-center">Digital Learning Ecosystem</h1>
    <p class="lead text-center mb-5">
      Exploring the intersection of <strong>Educational Technology</strong>, <strong>Human–Computer Interaction</strong>, 
      <strong>Virtual Learning Environments</strong>, and the <strong>Linux Learning Layer</strong> to experiment, prototype, 
      and develop research-informed, engaging, and future-ready Computer Science education.
    </p>
    //<div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4"></div>
   <div class="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4">
      <div class="col" v-for="(course, index) in courses" :key="index">
        <div class="card h-100 shadow-sm">
          <div class="card-body">
            <h5 class="card-title fw-semibold fs-5">{{ course.title }}</h5>
            <h6 class="card-subtitle mb-2 text-muted fs-6">{{ course.level }}</h6>
            <p class="card-text fs-6 lh-base">{{ course.description }}</p>
        
          </div>
          <div class="card-footer bg-transparent border-top-0">
            <!-- button class="btn btn-custom"  @click="openModal(course)">View More</button-->
         <a :href="course.link" class="btn btn-custom">
    View More
</a>
          </div>
        </div>
      </div>
</div>

    
  </div>
 <!-- Modal -->
<div
  class="modal fade"
  tabindex="-1"
  :class="{ show: showModal }"
  style="display: block;"
  v-if="showModal"
>
  <div class="modal-dialog">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedCourse.title }}</h5>
        <button type="button" class="btn-close" @click="closeModal"></button>
      </div>
      <div class="modal-body">
        <p><strong>Topics Covered:</strong></p>
        <ul>
          <li v-for="(topic, index) in selectedCourse.topics" :key="index">{{ topic }}</li>
        </ul>
      <p class="text-success">Detailed learning objectives and outcomes are available.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'CoursesView',
  data() {
    return {
       selectedCourse: null,
       showModal: false,
      courses: [
        {
          id: 1,
          title: 'Educational Technology',
          level: '(EdTech)',
          description: 'Exploring research-informed teaching strategies, digital pedagogy, learning frameworks, and emerging technologies that enhance Computer Science education and support engaging, inclusive, and future-ready learning experiences.',
            topics: [
          "Stages of development life cycle",
          "Development methodology (OOP)",
          "Effective portfolio/documentation",
          "Refining your work",
          "Effective and engaging practices"
        ],
        link:'/educational-technology'
        },
        {
          id: 2,
          title: 'Human–Computer Interaction',
          level: '(HCI)',
          description: 'Investigating how learners interact with technology through user-centred design, usability, accessibility, and interactive experiences that make Computer Science concepts more intuitive and meaningful.',
            topics: ["Understanding the real-world objects aound us",
                    "Identifying the characteristics + behaviour of objects",
                    "How objects represented in the virtual/program environment",
                    "Properties of OOP",
                    "Conceptualizing program as a collection of objects",
                    "How objects communicate & interact during the execution of program",
                    "Developing an app using the OOP approach"
            ],
              link:'/human-computer-interaction'
        },
        {
          id: 3,
          title: 'Virtual Learning Environment',
          level: '(VLE)',
          description: 'Designing and experimenting with virtual labs, authentic computing activities, and interactive learning scenarios that allow students to explore, practise, and reflect through hands-on experience.',
           topics: [
            
           "Cybersecurity is not just about defending against attackers and viruses — it’s about how we keep our information safe, build trust in online systems, and make technology work securely for everyone.",

          "Through practical examples and clear explanations, we’ll learn how digital systems protect our identity, data, and actions.",

          "You’ll leave this course with a better understanding of how cybersecurity works for you — not just against threats",
           
           "Learning Outcomes",

            "By the end of this course, you will be able to:",

             "1) Distinguish between cyberspace, networks, and the Internet, and explain their roles in digital communication.",

            "2) Understand the purpose of cybersecurity and how it helps protect data, identity, and transactions.",

            "3) Recognize real-world applications of cybersecurity, such as:",

               "  3.1) Logging into an online platform using Google or other identity providers.",
               "  3.2) Safely completing an online shopping transaction.",
               "  3.3) Verifying your identity via email confirmation and registration systems.",




           ],
             link:'/virtual-learning-environment'
        },
        {
          id: 4,
          title: 'Linux Learning Layer',
          level: '(LLL)',
          description: 'Providing the open computing infrastructure that powers experimentation, prototyping, networking, programming, cybersecurity, cloud, and virtual learning experiences through Linux-based technologies.',
           topics: ["How automated systems evolved into present intelligent systems",
                  "Introduction to AI",
                  "Types of AI",
                  "Fundemental ideas in AI",
                  "How Path finding algorithms helps us understand AI",
                  "Applying the basic AI algorthims to different practical scenarios."
           ],
             link:'/learn-linux'
        },
       
       
      ]
    }
  },
  methods: {
    openModal(course) {
      this.selectedCourse = course;
      this.showModal = true;
      document.body.classList.add("modal-open"); // Prevents scroll flicker
    },
    closeModal() {
      this.showModal = false;
      this.selectedCourse = null;
      document.body.classList.remove("modal-open");
    }
  }




}
</script>

<style scoped>
.card-title {
  font-weight: bold;
}
.card {
  border: 1px solid #d4eadd;
  background-color: #f9fdfb; /* light green background */
}

.card-title {
  color: #1e5f3d; /* dark green */
  font-weight: bold;
}

.card-text {
  color: #333;
}

.badge {
  background-color: #198754; /* Bootstrap's success green */
}

.btn-custom {
  background-color: #198754; /* Green */
  color: white;
  border: 2px solid #198754;
  transition: all 0.3s ease;
}

.btn-custom:hover {
  background-color: white;
  color: #198754;
  border: 2px solid #198754;
}

.modal {
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
}
.modal-open {
  overflow: hidden;
}
</style>
